import { debounce } from '@a11y/focus-trap/debounce';

function addListener($target, type, listener, options, debounceMs) {
    const types = Array.isArray(type) ? type : [type];
    const debounceId = Math.random().toString();
    const cb = e => debounceMs == null ? listener(e) : debounce(() => listener(e), debounceMs, debounceId);
    types.forEach(t => $target.addEventListener(t, cb, options));
    return () => types.forEach(t => $target.removeEventListener(t, cb, options));
}
function removeListeners(listeners) {
    listeners.forEach(unsub => unsub());
    listeners.length = 0;
}
function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
function addClickAwayListener($areas, listener) {
    return addListener(window, [
        'mousedown',
        'pointerdown'
    ], e => {
        if (!('composedPath' in e))
            return;
        const paths = e.composedPath();
        if ($areas.find($area => paths.includes($area)) == null) {
            listener();
        }
    }, { passive: true });
}

export { addClickAwayListener, addListener, removeListeners, stopEvent };
